import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadLadder } from 'utils/betslip/odd-formats-helper';
import { setOddsFormat } from 'utils/betslip/odds-format';
import { updateOddFormat } from 'store/actions/betslip';
import { getLadderLoaded, getOddFormat } from 'store/selectors/betslip';

export const useChangeOddFormat = (): ((id: number, value: string) => void) => {
  const oddFormat = useSelector(getOddFormat);
  const ladderLoaded = useSelector(getLadderLoaded);
  const dispatch = useDispatch();

  const handle = useCallback(
    (id: number, value: string) => {
      if (value && oddFormat !== id) {
        if (value === 'fractional' && !ladderLoaded) {
          void loadLadder(id);
        } else {
          dispatch(updateOddFormat(id));
        }

        setOddsFormat(value);
      }
    },
    [oddFormat, ladderLoaded]
  );

  return handle;
};
